import mapboxgl from "mapbox-gl";
require('@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css')
require('../../../../../node_modules/mapbox-gl/dist/mapbox-gl.css')
require('@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css');
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

var searchBox = 'Pesquisar...';


import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BCardText,
    BInputGroupAppend,
    BFormGroup, BFormSelect,
    BDropdownItem,
    BInputGroup,
    BFormCheckbox,
    BInputGroupPrepend,
    BCardBody, VBPopover,
    BPagination,
} from "bootstrap-vue";
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import gql from "graphql-tag";
import { avatarText } from "@core/utils/filter";

import moment from 'moment'
import 'moment-timezone';
import 'moment/locale/pt-br';
import { Form } from 'vform';

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

const ADD = gql`
mutation insertLocation($name : String!, $city_uuid : uuid!, $lat : float8!, $lng : float8!) {
    insert_locations(objects: { name: $name, city_uuid: $city_uuid, lat : $lat , lng : $lng}) {
      affected_rows
    }
  }
  
  `;

const UPDATE = gql`
mutation updateLocation($uuid_location: uuid!, $name : String!, $city_uuid : uuid, $lat : float8!, $lng : float8!) {
    update_locations(where: {uuid_location: {_eq: $uuid_location}}, _set: {city_uuid: $city_uuid, name: $name, lat : $lat , lng : $lng}) {
      affected_rows
    }
  }
  
  `;

const DELETE = gql`
mutation deleteLocation($uuid_location: uuid!) {
    delete_locations(where: {uuid_location: {_eq: $uuid_location}}) {
      affected_rows
    }
  }
  
  `;

const GET = gql`
query getLocations {
    locations {
      uuid_location
      name
      lat
      lng
      city {
        uuid_city
        name
        state {
         uf
         name
        }
      }
    }
  }   
  `;

const GET_CITIES = gql`
query getCities {
    cities {
      uuid_city
      name
      state {
        uf
        name
       }
    }
  }  
  `;

export default {
    components: {
        ToastificationContent,
        quillEditor,
        flatPickr,
        BCardText,
        BCard,
        BRow,
        BCol,
        BFormInput,
        BCardBody,
        BCardCode,
        BFormCheckbox,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BFormGroup, BFormSelect,
        BLink,
        BInputGroupAppend,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BInputGroup,
        BInputGroupPrepend,

        vSelect,
    },
    directives: {
        'b-popover': VBPopover,
    },
    data() {
        return {
            titleForm: 'Adicionar local',
            snowOption: null,
            editMode: false,
            cities: null,
            form: new Form({
                uuid_location: null,
                city_uuid: null,
                name: null,
                lat: null,
                lng: null,
            }),
            /* MapBox Data */
            isDisabled: false,
            isEdit: false,
            renderizeMap: false,
            accessToken: 'pk.eyJ1IjoiYXpkaWdpdGFsIiwiYSI6ImNrYTkxbGJhZDBuNXoyem50NXFqNG55NnIifQ.JUvEggWaDTk4qUC4B6BoJg',
            marker: null,
            map: null,
            /* End MapBox Data */
            perPage: 5,
            pageOptions: [5, 10, 15],
            totalRows: 1,
            currentPage: 1,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            fields: [
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'city.name', label: 'Cidade', sortable: true },
                { key: 'city.state.uf', label: 'Estado', sortable: true },
              /*   { key: 'lat', label: 'Latitude', sortable: false },
                { key: 'lng', label: 'Longitude', sortable: false }, */
                { key: 'actions', label: 'Ações', sortable: false },
            ],
            items: [],
        }
    },
    computed: {
        sortOptions() {
            return this.fields
                .filter(f => f.sortable)
                .map(f => ({ text: f.label, value: f.key }))
        },
    },
    created() {
        moment.locale('pt-br')

        this.getRecords();

    },

    methods: {
        initMap(param) {
            let that = this;
            mapboxgl.accessToken = this.accessToken;

            if (param == 'add') {
                this.map = new mapboxgl.Map({
                    container: "mapLocationContainer",
                    style: "mapbox://styles/mapbox/satellite-v9",
                    center: [-49.4299243, -26.0995525],
                    zoom: 1,
                });

                /* Location  Marker */
                that.marker = new mapboxgl.Marker({ draggable: true, color: "orange" })
                    .setLngLat([-49.4299243, -26.0995525],)
                    .addTo(that.map);

                this.marker.on('dragend', function (e) {
                    that.form.lng = e.target._lngLat.lng;
                    that.form.lat = e.target._lngLat.lat;
                    var bounds = new mapboxgl.LngLatBounds();
                    bounds.extend([e.target._lngLat.lng, e.target._lngLat.lat])
                    that.map.flyTo({
                        speed: 3,
                        center: [e.target._lngLat.lng, e.target._lngLat.lat],
                        zoom: 17.5,
                    });
                });

                /* End Location Marker */

                /* Search Box */
                var geocoder = new MapboxGeocoder({ // Initialize the geocoder
                    accessToken: mapboxgl.accessToken, // Set the access token
                    mapboxgl: mapboxgl, // Set the mapbox-gl instance
                    placeholder: searchBox,
                    marker: true, // Do not use the default marker style
                });
                // Add the geocoder to the map
                that.map.addControl(geocoder);

                geocoder.on('result', function (e) {
                    geocoder.clear();
                    that.form.lng = e.result.center[0];
                    that.form.lat = e.result.center[1];

                    if (!that.marker) {
                        that.marker = new mapboxgl.Marker({ draggable: true, color: "orange" })
                            .setLngLat(e.result.center)
                            .addTo(that.map)
                        that.map.flyTo({
                            center: [that.marker._lngLat.lng, that.marker._lngLat.lat],
                            zoom: 17.5,
                        });
                    } else {
                        that.marker.setLngLat(e.result.center)
                        that.map.flyTo({
                            center: e.result.center,
                            zoom: 17.5,
                        })
                    }
                })

                const nav = new mapboxgl.NavigationControl();
                this.map.addControl(nav, "top-right");

            } else {
                this.map = new mapboxgl.Map({
                    container: "mapLocationContainer",
                    style: "mapbox://styles/mapbox/satellite-v9",
                    center: [that.form.lng, that.form.lat],
                    zoom: 1,
                });

                /* Location  Marker */
                that.marker = new mapboxgl.Marker({ draggable: true, color: "orange" })
                    .setLngLat([that.form.lng, that.form.lat],)
                    .addTo(that.map);
                that.map.flyTo({
                    speed: 3,
                    center: [that.form.lng, that.form.lat],
                    zoom: 17.5,
                });

                that.marker.on('dragend', function (e) {
                    that.form.lng = e.target._lngLat.lng;
                    that.form.lat = e.target._lngLat.lat;
                    var bounds = new mapboxgl.LngLatBounds();
                    bounds.extend([e.target._lngLat.lng, e.target._lngLat.lat])
                    that.map.flyTo({
                        speed: 3,
                        center: [e.target._lngLat.lng, e.target._lngLat.lat],
                        zoom: 17.5,
                    });
                });

                /* End Location Marker */

                /* Search Box */
                geocoder = new MapboxGeocoder({ // Initialize the geocoder
                    accessToken: mapboxgl.accessToken, // Set the access token
                    mapboxgl: mapboxgl, // Set the mapbox-gl instance
                    placeholder: searchBox,
                    marker: true, // Do not use the default marker style
                });
                // Add the geocoder to the map
                that.map.addControl(geocoder);

                geocoder.on('result', function (e) {
                    geocoder.clear();
                    that.form.lng = e.result.center[0];
                    that.form.lat = e.result.center[1];

                    if (!that.marker) {
                        that.marker = new mapboxgl.Marker({ draggable: true, color: "orange" })
                            .setLngLat(e.result.center)
                            .addTo(that.map)
                        that.map.flyTo({
                            center: [that.marker._lngLat.lng, that.marker._lngLat.lat],
                            zoom: 17.5,
                        });
                    } else {
                        that.marker.setLngLat(e.result.center)
                        that.map.flyTo({
                            center: e.result.center,
                            zoom: 17.5,
                        })
                    }
                })

                const nav = new mapboxgl.NavigationControl();
                this.map.addControl(nav, "top-right");

            }
        },
        newLocations() {
            this.titleForm = 'Adicionar Local',
                this.editMode = false;
            this.form.reset();
            this.$refs['locationsModal'].show()
            this.renderizeMap = true;
            this.isDisabled = false;
            this.map = null;
            this.marker = null;
            setTimeout(() => this.initMap('add'), 100);

        },
        newLocation() {
            let {

                name,
                lat,
                lng,
            } = this.$data.form;

            let city_uuid = this.form.city_uuid.uuid_city


            this.$apollo.mutate({
                mutation: ADD,
                variables: {
                    city_uuid,
                    name,
                    lat,
                    lng,
                }
            }).then(() => {
                this.getRecords();
                this.$refs['locationsModal'].hide()
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Sucesso',
                        icon: 'CheckIcon',
                        text: 'Local adicionado!',
                        variant: 'success',
                    },
                },
                    {
                        position: 'bottom-right',
                    })
            }).catch((error) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Erro',
                        icon: 'XIcon',
                        text: 'Local não adicionado! ' + error,
                        variant: 'danger',
                    },
                },
                    {
                        position: 'bottom-right',
                    })
            });
        },
        editLocation(c) {
            this.titleForm = 'Editando Local';
            this.editMode = true;
            this.$data.form.fill(c);
            this.form.city_uuid = c.city
            this.renderizeMap = true;
            this.isDisabled = false;
            this.map = null;
            this.marker = null;
            setTimeout(() => this.initMap('edit'), 100);
            this.$refs['locationsModal'].show()


        },
        updateLocation() {
            let {
                name,
                lat,
                lng,
                uuid_location,
            } = this.$data.form;
            let uuid_city = this.form.city_uuid.uuid_city

            this.$apollo.mutate({
                mutation: UPDATE,
                variables: {
                    name,
                    lat,
                    lng,
                    city_uuid: uuid_city,
                    uuid_location: uuid_location,
                }
            }).then(() => {
                this.getRecords();
                this.$refs['locationsModal'].hide()
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Sucesso',
                        icon: 'CheckIcon',
                        text: 'Local atualizado!',
                        variant: 'success',
                    },
                },
                    {
                        position: 'bottom-right',
                    })
            }).catch((error) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Erro',
                        icon: 'XIcon',
                        text: 'Erro ao atualizar Local! ' + error,
                        variant: 'danger',
                    },
                },
                    {
                        position: 'bottom-right',
                    })
            });
        },

        deleteLocation(uuid) {

            this.$bvModal
                .msgBoxConfirm('Deseja realmente excluir este Local?', {
                    title: 'ATENÇÃO!',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Sim',
                    cancelTitle: 'Não',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if (value == true) {
                        this.$apollo.mutate({
                            mutation: DELETE,
                            variables: {
                                uuid_location: uuid
                            }
                        }).then(() => {
                            this.getRecords();
                            this.$refs['locationsModal'].hide()
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: 'Sucesso',
                                    icon: 'CheckIcon',
                                    text: 'Local deletado!',
                                    variant: 'success',
                                },
                            },
                                {
                                    position: 'bottom-right',
                                })
                        }).catch((error) => {
                            this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: 'Erro',
                                    icon: 'XIcon',
                                    text: 'Erro ao excluir o Local! ' + error,
                                    variant: 'danger',
                                },
                            },
                                {
                                    position: 'bottom-right',
                                })
                        });
                    }
                })


        },
        formatFullDate(data) {
            return moment(data).format("DD/MM/YY [às] HH:mm:ss")
        },
        formatDatetoUpdate(data) {
            return moment(data).format("MM-DD/YY")
        },
        getRecords() {
            this.$apollo.query({
                query: GET,
                fetchPolicy: 'no-cache',
            }).then((data) => {
                this.items = data['data']['locations'];
                this.totalRows = this.items.length
            });

            this.$apollo.query({
                query: GET_CITIES,
                fetchPolicy: 'no-cache',
            }).then((data) => {
                this.cities = data['data']['cities'];
            });


        },

        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
    },
    setup() {
        return {
            avatarText,
        }
    }


}